// Matrix Heading Toggle
const matrixHeading = document.querySelectorAll('.custom-product .tabs-custom li a');

matrixHeading.forEach((heading) => {
    heading.addEventListener('click', (e) => {
        e.preventDefault();
        clearFields();
        matrixHeading.forEach((heading) => {
            heading.classList.remove('active');
        });
        heading.classList.add('active');
        const currentTab = heading.parentElement.classList[0];
        const tabContent = document.querySelectorAll('.custom-product .tabs-content-matrix li');
        tabContent.forEach((tab) => {
            // if currentTab matches add active id then other remove class
            if ( tab.classList == currentTab ) {
                tab.classList.add('active');
            }
            else {
                tab.classList.remove('active');
            }
        });
    });
});

function clearFields() {
  const verifyActive = document.querySelector('.theme-init');
  const loopMatrixQty = verifyActive.querySelectorAll('.input-group input');
  loopMatrixQty.forEach((item) => {
    item.value = 0;
  } );
}

// Matrix Quantity Update
const qtySelector = document.querySelectorAll('.custom-product .product_form_list .input-group button');

qtySelector.forEach((qty) => {
    qty.addEventListener('click', (e) => {
        e.preventDefault();
        const input = qty.parentElement.querySelector('input');
        const inputValue = parseInt(input.value);
        if (qty.classList.contains('plus-symbol')) {
            input.value = inputValue + 1;
        } else if (inputValue >= 1) {
            input.value = inputValue - 1;
        }
        // Updater on click
        backOrderChecker(qty, input);
    });
});

const qtyInputSelector = document.querySelectorAll('.custom-product .product_form_list .input-group .qty-input');
qtyInputSelector.forEach((qty) => {
  qty.addEventListener('input', (e) => {
    const input = qty.parentElement.querySelector('input');
    // Updater on click
    backOrderChecker(qty, input);
  });
});

function backOrderChecker(qty, input) {
   // Update
   const getLineStock = qty.parentNode.parentNode.parentNode;
   const getLineStockValue = qty.parentNode.querySelector('.qty-input');
   
   getDataLineVal = getLineStock.getAttribute('data-line');
   getDataLine = `[data-line="${getDataLineVal}"]`;
   loopLine = document.querySelectorAll(getDataLine);

   if ( parseInt( getLineStockValue.getAttribute('data-variant-qty')) != '0' ) {
      if ( input.value  > parseInt( getLineStockValue.getAttribute('data-variant-qty')) ) {
      
        if ( getLineStock.classList.contains('inline-tooltip') ) {
        loopLineInner = getLineStock.querySelectorAll('.instock-line');
        loopLineInner.forEach((el) => {
          el.textContent = "Due Soon – Order Now";
          el.style.color = '#333';
        });
        } else {
        loopLine.forEach((el) => {
          el.querySelector('.instock-line').textContent = "Due Soon – Order Now";
          el.querySelector('.instock-line').style.color = '#333';
          el.querySelector('.instock-line').style.fontWeight = 'normal';
        });
        }
      } else {
      
        if ( getLineStock.classList.contains('inline-tooltip') ) {

          loopLineInner = getLineStock.querySelectorAll('.instock-line');
          loopLineInner.forEach((el) => {
            el.textContent = "In Stock";
            el.removeAttribute('style');
          });

          
        } else {
          loopLine.forEach((el) => {
            el.querySelector('.instock-line').textContent = "In Stock";
            el.querySelector('.instock-line').removeAttribute('style');
          });
        }
      }
   }
    
}


// Product Specification Tabs
const productSpecTabs = document.querySelectorAll('.product-tabs .heading li');

productSpecTabs.forEach((heading) => {
    heading.addEventListener('click', (e) => {
        e.preventDefault();
        productSpecTabs.forEach((heading) => {
            heading.classList.remove('active');
        });
        heading.classList.add('active');
        const currentTab = heading.parentElement.classList[0];
        const tabContent = document.querySelectorAll('.custom-product .tabs-content li');
        tabContent.forEach((tab) => {
            // if currentTab matches add active id then other remove class
            if ( tab.classList == currentTab ) {
                tab.classList.add('active');
            }
            else {
                tab.classList.remove('active');
            }

        });


    });
});

productSpecTabs.forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const currentTab = el.getAttribute('data-tab');
    const tabContent = document.querySelectorAll('#tabs-content .tab-content');
    tabContent.forEach((heading) => {
      heading.classList.remove('active');
      heading.removeAttribute('style');
    });
    tabContent.forEach((tab) => {
        // if currentTab matches add active id then other remove class
        const contentTab = tab.getAttribute('data-tab');
        
        if ( contentTab == currentTab ) {
            tab.classList.add('active');
            setTimeout(function(){ tab.style.opacity = 1; }, 100);
            
        }
        else {
            
        }

    });
  });
});

// Product Variants on mobile
if ( document.querySelector(".column-flex.input-field.full") ) {
  document.querySelector(".column-flex.input-field.full").classList.remove('mobile-variant-hidden');
}

document.querySelectorAll('#mobile-variants-wrapper select').forEach(function(selectElement) {
  selectElement.addEventListener('change', function(e) {
    var mobileVariantChosen = '';

    var checkETA = document.querySelector('.eta-messaging');

    // clear ETA message
    if ( checkETA ) {
      checkETA.innerHTML = '';
      checkETA.classList.add('reset');
    }
    
    document.querySelectorAll('#mobile-variants-wrapper select').forEach(function(select) {
      mobileVariantChosen += " / " + select.options[select.selectedIndex].text;
    });
    
    document.querySelectorAll(".column-flex.input-field.full").forEach(function(column) {
      column.classList.add('mobile-variant-hidden');
    });

    document.querySelectorAll(".column-flex.input-field input[type='text']").forEach(function(input) {
      input.value = 0;
    });
    if ( document.querySelector("[data-variant='" + mobileVariantChosen + "']")) {
      document.querySelector("[data-variant='" + mobileVariantChosen + "']").classList.remove('mobile-variant-hidden');
      // Check ETA message
      var dataEtaChecker = document.querySelector("[data-variant='" + mobileVariantChosen + "']");
      var dataEta = dataEtaChecker.getAttribute('data-eta');
      var dataInventory = dataEtaChecker.getAttribute('data-inventory');
      if ( dataInventory > 0 && checkETA  ) {
        var defaultMessage = checkETA.getAttribute('data-message');
        if ( defaultMessage ) {
          checkETA.classList.remove('reset');
          checkETA.innerHTML = defaultMessage;
        } else {

        }
      } else {
        if ( dataEta ) {
          if ( checkETA ) {
            checkETA.classList.remove('reset');
            checkETA.innerHTML = `Lead Time: ${dataEta}`;
          }
        }
      }
    }
    
  });
});


// on click save to local storage
const prevPageProduct = document.querySelector('.login-for-price');
if (prevPageProduct) {
  prevPageProduct.addEventListener('click', (e) => {
    // get current browser link
    const getProductUrl = window.location.href;
    localStorage.setItem("prevStateUrl", getProductUrl);
    
  });
}

